import { rem } from 'polished'
import React, { useContext } from 'react'
import styled from 'styled-components'

import Image from 'components/Common/Image'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import ContactContext from 'contexts/contactContext'

export const CUSTOMER_SUPPORT_IMAGE_ID = 'kxio114neo48t74rpdzs'

const IMAGE_WIDTH = 100
const IMAGE_HEIGHT = 120

const Container = styled.div`
  display: grid;
  grid-template-columns: ${rem(IMAGE_WIDTH)} 1fr;
  align-items: center;
  gap: ${rem(16)};

  picture,
  image {
    width: ${rem(IMAGE_WIDTH)};
    height: ${rem(IMAGE_HEIGHT)};
  }
`

function CustomerSupportBlock() {
  const supportPhone = useContext(ContactContext)

  return (
    <Container>
      <Image
        alt="Travel companion on your trip"
        id={CUSTOMER_SUPPORT_IMAGE_ID}
        width={IMAGE_WIDTH}
        height={IMAGE_HEIGHT}
        fit="center"
      />
      <VerticalSpacer gap={8}>
        <Heading variant="heading6">
          Our team are available 24 hours, 7 days
        </Heading>
        <BodyText variant="medium">
          Can't find the right Curated Trip? Call us anytime and we'll create
          one for you!
        </BodyText>
        <TextLink
          startIcon={<LinePhoneIcon />}
          href={`tel:${supportPhone.local.number}`}
        >
          {supportPhone.local.humanReadable}
        </TextLink>
      </VerticalSpacer>
    </Container>
  )
}

export default CustomerSupportBlock
